<template>
    <div>
        <p>
            Please, choose a <b>JPEG, PNG or GIF</b> image. It will be automatically cropped and resized,
            so it is better if the face of the user is centered in the initial image.
        </p>

        <trax-ui-dropzone
            v-model="file"
            :url="endpoint"
            :options="options"
            @addedfile="addedFile"
            @error="error"
            @complete="complete"
            @success="success"
            preview-classes="thumbnail"
            inner-preview-classes="inner-thumbnail"
            image-preview-classes="image-thumbnail"
        ></trax-ui-dropzone>

        <div class="text-center font-weight-bold text-danger mb-3" v-if="errorFound">
            <small>Sorry, something went wrong!</small>
        </div>
                
        <div class="trax-form-actions text-center">
            <button type="submit" class="btn btn-primary btn-round"
                v-if="readyToUpload"
                :loading="uploading"
                @click="upload"
            >
                Upload
            </button>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'trax-account-user-edit'},
            userId: {default: null},
        },

        data() {
            return {
                endpoint: app_url + 'polaris/api/front/users/'+this.userId+'/avatar',
                options: {
                    autoProcessQueue: false,
                    acceptedFiles: 'image/jpeg,image/png,image/gif',
                    thumbnailWidth: 140,
                    thumbnailHeight: 140,
                    resizeWidth: 140,
                    resizeHeight: 140,
                    resizeQuality: 1.0,
                    resizeMethod: 'crop',
                    resizeMimeType: 'image/jpeg',
                },
                file: null,
                dropzone: null,
                readyToUpload: false,
                uploading: false,
                errorFound: false,
                bus: this.$bus
            }
        },

        methods: {

            addedFile(event) {
                this.dropzone = event.dropzone
                this.errorFound = false
                this.readyToUpload = true
            },

            upload() {
                this.errorFound = false
                this.uploading = true
                this.dropzone.processQueue()
            },

            complete(event) {
                this.uploading = false
                this.readyToUpload = false
                /*
                this.errorFound = event.args[0].status != 'success'
                */
            },

            error(event) {
                this.errorFound = true
            },

            success(event) {
                this.file = null
                this.dropzone.removeAllFiles()
                this.bus.$emit(this.id+'-data', event.args[1].data)
            },
        }
    }
</script>

<style scoped>

    .card >>> .thumbnail {
        width: 140px;
        height: 140px;
        left: 50%;
        right: auto;
    }
    .card >>> .inner-thumbnail {
        position: relative;
        left: -50%;
        right: auto;
    }
    .card >>> .image-thumbnail {
        border-radius: 50% !important;
    }

</style>
